import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewBoardModule"
const debug = false

export class ViewBoardModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_BOARD, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Board"
        this.description                = "The Board View is a dynamic and versatile tool for task management, offering a visually engaging interface for organizing and tracking tasks. Users can utilize Kanban boards to visualize their workflow and easily move tasks between different stages. Additionally, the Board View supports a matrix view, enabling users to group tasks not only by columns but also by rows, providing a customizable and comprehensive perspective on task organization."
        this.svgIcon                    = "isvg-view-board"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-board"
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.parentSection              = SettingsParentSection.VIEWS


    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}